import {h} from 'ui/Framework';

export default h('svg', {
  width: '81',
  height: '21',
  viewBox: '-1 -1 83 23',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, [
    h('g', {
      fill: '#D6DDE5'
    }, [
      h('g', [
        h('path', {
          d: 'M36.006 17.663C10.006 13.33 2.537 2.736 2.537 2.736s7.469 13.194 33.469 16.66c26 3.467 45.066-6.933 45.066-6.933s-19.066 9.533-45.066 5.2z'
        }),
        h('path', {
          d: 'M1.674 1.92c-2.142 8.665-.333 14.093-.333 14.093s.858-9.904 2.69-11.737C5.865 2.444 14.912.635 14.912.635s-9.047 0-13.237 1.284z'
        })
      ])
    ])
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/hint-arrow.es6.js